
class BSNav extends HTMLElement {
  static selectors = {
    dropdown: '.dropdown-toggle',
    imageContainer: '[data-menu-image-container]',
    images: '[data-menu-image]',
    item: '.nav-item'
  }
  static shownClass = 'dropdown-open';
  items; open;

  constructor(){
    super();
    this.init();
  } 

  init = () => {
    this.items = this.querySelectorAll(BSNav.selectors.item);
    this.querySelectorAll(BSNav.selectors.dropdown).forEach((dropdown) => {
      dropdown.addEventListener('shown.bs.dropdown', () => {
        this.classList.add(BSNav.shownClass);
        document.body.classList.add(BSNav.shownClass);
        this.open = true;
        const event = new CustomEvent("theme.nav_changed", { open: this.open });
        this.dispatchEvent(event);
      });
      dropdown.addEventListener('hidden.bs.dropdown', () => {
        this.classList.remove(BSNav.shownClass);
        document.body.classList.remove(BSNav.shownClass);
        this.open = false;
        const event = new CustomEvent("theme.nav_changed", { open: this.open });
        this.dispatchEvent(event);
      });
    });
    this.setOvers();
  }

  setOvers = () => {
    this.items.forEach((item) => {
      const imageContainer = item.querySelector(BSNav.selectors.imageContainer);
      if(imageContainer != null){
        item.querySelectorAll(BSNav.selectors.images).forEach((link) => {
          link.addEventListener('mouseover', () => {
            this.changeImage(link, imageContainer);
          });
        });
      }
    });
  }

  changeImage = (link, imageContainer) => {
    const img = imageContainer.querySelector('img');
    const title = imageContainer.querySelector('span');
    const picture = imageContainer.querySelector('picture');
    picture.querySelectorAll('source').forEach((e) => {
      e.remove();
    });
    img.src = link.dataset.menuImage;
    title.innerText = link.dataset.menuTitle;
    imageContainer.href = link.getAttribute('href');
  }  
}
if (!window.customElements.get("bs-nav")) {
  window.customElements.define("bs-nav", BSNav);
}